import { WebNavService } from './../../../web/webnavigation.service';
import { Component, Inject, OnDestroy, Optional } from '@angular/core';
import { FirebaseAuthService } from '../../providers/firebase-auth.service';
import { environment } from 'src/environments/environment';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { renderOnly } from '../../feature-flags';
import { renderLegalUrl } from 'src/app/web/render/legal/render-legal.data';

// Optional heading above the sign-in buttons: why the user is being asked to sign in right now
// (the boss's prototype puts the reason in the account popup — "Keep track of your request.").
// Callers that pass `data: {}` get the popup as before.
export interface AuthpopupContext {
  title?: string;
  text?: string;
}

@Component({
  selector: 'app-authpopup',
  templateUrl: './authpopup.component.html',
  styleUrls: ['./authpopup.component.scss']
})
export class AuthpopupComponent implements OnDestroy {
  public isUserAuthenticated: boolean;
  public isDev: boolean = !environment.production;
  // What signing in agrees to: on a render-only site the render service's own documents, elsewhere
  // the platform's.
  public readonly termsUrl = renderOnly ? renderLegalUrl('terms') : '/legal/terms-of-service';
  public readonly privacyUrl = renderOnly ? renderLegalUrl('privacy') : '/legal/privacy-policy';
  public errorMessage: string = '';
  public isActionActivated: boolean = false;

  ifEmailLoginShown: boolean = false;
  email: string = '';
  password: string = '';

  constructor(
    public authService: FirebaseAuthService,
    public webNavService: WebNavService,
    private dialogRef: MatDialogRef<AuthpopupComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public context: AuthpopupContext | null,
  ) { }

  async onSignInWithAppleClicked()  {
  this.isActionActivated = true;

    try {
      await this.authService.loginWithAppleWeb();

      // Check if we were opened from landing page and should redirect
      setTimeout(() => {
        // Close the dialog first
        this.dialogRef.close();
        this.webNavService.redirectToLibraryAfterAuth();
      }, 100);
    } catch (error) {

    }
  }

  async onSignInWithGoogleClicked()  {
  this.isActionActivated = true;

    try {
      await this.authService.loginWithGoogle();

      // Check if we were opened from landing page and should redirect
      setTimeout(() => {
              // Close the dialog first
      this.dialogRef.close();
        this.webNavService.redirectToLibraryAfterAuth();
      }, 100);
    } catch (error) {

    }
  }

  async onSignInWithEmailClicked()  {
    this.ifEmailLoginShown = true;
    console.log('onSignInWithEmailClicked');
  }

  async onSubmitLoginFormClicked()  {
  this.isActionActivated = true;

    try {
      await this.authService.loginWithEmailAndPassword(this.email, this.password);

      // Check if we were opened from landing page and should redirect
      setTimeout(() => {
              // Close the dialog first
      this.dialogRef.close();
        this.webNavService.redirectToLibraryAfterAuth();
      }, 100);
    } catch (error) {
      this.errorMessage = error;
    }
  }

  async signWithEmailLink() {
    this.authService.sendSignInLinkToEmail(this.email);
  }

  ngOnDestroy() {
    if(!this.isActionActivated) {
      this.webNavService.webAuthPopupClosed.emit(true);
    }


  }

}
